export const encodeSlug = (str) => {
    return btoa(
        encodeURIComponent(str).replace(
            /%([0-9A-F]{2})/g,
            (_, p1) => String.fromCharCode("0x" + p1)
        )
    )
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
};

export const decodeSlug = (str) => {
    let base64 = str
        .replace(/-/g, "+")
        .replace(/_/g, "/");

    while (base64.length % 4) {
        base64 += "=";
    }

    return decodeURIComponent(
        Array.prototype.map
            .call(atob(base64), (c) =>
                "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
            )
            .join("")
    );
};

export const generateSlug = (text = "") => {
    return text
        .toLowerCase()
        .normalize("NFKD")
        .replace(/[^\p{L}\p{N}]+/gu, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "");
};

/* export const getBookURL = (book) => {
    if (!book?._id || !book?.book_title) return window.location.origin;

    return `${window.location.origin}/book-details/${book._id}-${generateSlug(book.book_title)}`;
}; */

export const getBookURL = (book) => {
    if (!book?.id || !book?.book_title) {
        return window.location.origin;
    }

    const slugData = `${book.id}-${generateSlug(book.book_title)}`;
    /* console.log("Booooooook ID & Boook Title", slugData) */
    return `${window.location.origin}/book-details/${encodeSlug(slugData)}`;
};

export const shareBook = async (book) => {
    if (!book) return;

    const url = getBookURL(book);
    const title = book.book_title || "Book";

    if (navigator.share) {
        try {
            await navigator.share({
                title,
                url
            });
        } catch (error) {
            console.log("Error sharing:", error);
        }
    } else {
        try {
            await navigator.clipboard.writeText(url);
            alert("Link copied to clipboard!");
        } catch (error) {
            alert("Failed to copy link.");
        }
    }
};